const getFonts = config => {
  const { Fonts = {} } = config;
  return Fonts;
};

export default getFonts;
